import _ from "lodash";
import React, { useCallback, useMemo } from "react";
import { HTMLData_Source } from "./../../ricos-schema/next-schema/index.js";
import { DraggableHOC } from "./../../_shared/draggable-hoc.js";
import { isOnlyNodeSelected } from "./../../_shared/is-only-node-selected.js";
import { logInvariant } from "./../../_shared/log-invariant.js";
import { OverlayHoc } from "./../../_shared/overlay-hoc/overlay-hoc.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import { htmlConverter } from "./../html-converter.js";
import { HtmlViewer as HtmlViewerComponent } from "../viewer/html-viewer.js";
import { AiWidget } from "./ai-widget.js";
const Html = ({ settings: config, node, ...props }) => {
  const { patchPmNodeAttrs, pmNodeAttrs } = useNodeAttrs(node.attrs.id, "HTML");
  if (!pmNodeAttrs) {
    logInvariant(new Error("pmNodeAttrs is undefined"));
    return null;
  }
  const onIframeHeightChange = useCallback(
    (height) => {
      if (height !== pmNodeAttrs?.iframeHeight) {
        patchPmNodeAttrs?.({
          ...pmNodeAttrs,
          containerData: { ...pmNodeAttrs.containerData, height: { custom: `${height}` } },
          iframeHeight: height
        });
      }
    },
    [pmNodeAttrs, patchPmNodeAttrs]
  );
  const ricosNode = useMemo(() => htmlConverter.fromPm.convert(node.toJSON()), [node]);
  const isSelected = isOnlyNodeSelected(props.editor.state, node.attrs.id);
  if (ricosNode?.htmlData?.source === HTMLData_Source.AI && config.enableAiMode) {
    return /* @__PURE__ */ React.createElement(AiWidget, { ricosNode }, /* @__PURE__ */ React.createElement(
      HtmlViewerWithOverlay,
      {
        ...props,
        htmlData: ricosNode?.htmlData,
        settings: config,
        onIframeHeightChange,
        disabled: isSelected
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(
    HtmlViewerWithDragAndOverlay,
    {
      ...props,
      htmlData: ricosNode?.htmlData,
      settings: config,
      onIframeHeightChange
    }
  );
};
const HtmlViewerWithDragAndOverlay = _.flowRight(DraggableHOC, OverlayHoc)(HtmlViewerComponent);
const HtmlViewerWithOverlay = _.flowRight(OverlayHoc)(HtmlViewerComponent);
export {
  Html
};
//# sourceMappingURL=component.js.map
